<qp-button
    [icon]="Icons.device_download_log"
    [name]="AppStrings.Device_LogDownload"
    [label]="AppStrings.Device_LogDownload"
    [colour]="''"
    [outline]="false"
    [disabled]="disabled"

    (clickL)="onClick($event)"
>
</qp-button>